// Minimal frontend adapter: byte-identical B1 hierarchy and VAT modules only.
module.exports = { ...require("./hierarchy"), ...require("./tax") };
